import { createAsyncThunk } from "@reduxjs/toolkit";
import homepage from "./mockData/homePageData";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getpagedata = async (credentials) => {


  //const response = await fetch(`${BASE_URL}/unipro/meta-data/page/${credentials}`, {
  //   method: "GET",
  //   credentials: 'include',
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  // });

  // if (!response.ok) {
  //   throw new Error("Internal Server Error");
  // }

  return homepage;
};


export const getPageMetaData = createAsyncThunk("pagedata/getPageMetaData", async (credentials, { rejectWithValue }) => {
  try {
    const response = await getpagedata(credentials);
    console.log("Mock Page Data:", response);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


